import { Component } from "@angular/core";
import { LogoComponent } from "@shared/components/atoms/logo/logo.component";
import { SearchBarComponent } from "@shared/components/molecules/search-bar/search-bar.component";
import { TranslatePipe } from "@ngx-translate/core";
import { InfoBannerComponent } from "@shared/components/molecules/info-banner/info-banner.component";

@Component({
  selector: "app-mobile-header",
  imports: [LogoComponent, SearchBarComponent, TranslatePipe, InfoBannerComponent],
  templateUrl: "./mobile-header.component.html",
  styleUrl: "./mobile-header.component.scss",
})
export class MobileHeaderComponent {}
